import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
  Pencil,
  Search,
  Funnel,
  Trash2,
  Edit2,
  Plus,
  MoreHorizontal,
  ChevronsUpDown,
  ChevronLeft,
  ChevronRight,
  X,
  Copy
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import apiHelper from '../../apiHelper';
import { copyToClipboard } from '../../utils/helper';
import Pagination from '../../components/Pagination';
import SortableHeader from '../../components/SortableHeader';
import FilterDrawer from '../../components/FilterDrawer';
import SearchBox from '../../components/SearchBox';

const PAGE_SIZE = 10;

const Company = () => {
  const history = useHistory();
  const location = useLocation();
  const [entities, setEntities] = useState([]);
  const [organisation, setOrganisation] = useState([]);
  const [workplaces, setWorkplaces] = useState([]);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [wpFilterOpen, setWpFilterOpen] = useState(false);
  const [wpSearchTerm, setWpSearchTerm] = useState('');
  const [wpSearchStatus, setWpSearchStatus] = useState([]);
  const [wpSearchLocationType, setWpSearchLocationType] = useState([]);
  const [wpSearchAddress, setWpSearchAddress] = useState([]);
  const [wpAddressSearchTerm, setWpAddressSearchTerm] = useState('');
  const [wpCurrentPage, setWpCurrentPage] = useState(1);
  const [wpSelectedIds, setWpSelectedIds] = useState([]);
  const [wpTempFilters, setWpTempFilters] = useState({
    status: wpSearchStatus,
    location_type: wpSearchLocationType,
    address: wpSearchAddress,
  });
  const [entityFilterDrawerOpen, setEntityFilterDrawerOpen] = useState(false);
  const [entityFilterValues, setEntityFilterValues] = useState({
    status: [],
    parentEntity: [],
    parentEntitySearch: ""
  });


  const handleToggleStatus = async (row) => {
    const activate = row.status_text !== 'Active';
    const action = activate ? 'activate' : 'deactivate';
    const updateData = { status: action };
    const response = await apiHelper(`entities/update-status/${row.entity_id}/`, 'POST', updateData);
    if (response && response.ok) {
      setEntities(entities.map(e =>
        e.entity_id === row.entity_id
          ? { ...e, status_text: activate ? 'Active' : 'Inactive' }
          : e
      ));
      setDropdownOpenId(null);
    }
  };

  const [activeTab, setActiveTab] = useState(() => location.state?.tab || "organisation-info");

  const formatTab = (tab) =>
    tab.replace("-", " ").replace(/\b\w/g, (l) => l.toUpperCase());

  const breadcrumbs = [
    "Organisations",
    "Company",
    formatTab(activeTab)
  ];

  const [searchTerm, setSearchTerm] = useState('');
  const [entitySearchStatus, setEntitySearchStatus] = useState([]);
  const [entitySearchParent, setEntitySearchParent] = useState([]);
  const [entityParentSearchTerm, setEntityParentSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTab, setDrawerTab] = useState('entity-info');
  const [selectedRow, setSelectedRow] = useState(null);

  const filtered = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return entities.filter(d => {
      const matchesSearch =
        !searchTerm ||
        d.entity_name.toLowerCase().includes(term) ||
        d.uen.toLowerCase().includes(term) ||
        d.note.toLowerCase().includes(term) ||
        d.entity_short_name.toLowerCase().includes(term) ||
        d.uuid.toLowerCase().includes(term);
      const matchesStatus = entitySearchStatus.length === 0 || entitySearchStatus.includes(d.status_text);
      const matchesParent = entitySearchParent.length === 0 || entitySearchParent.includes(d.parent_name || 'NA');
      return matchesSearch && matchesStatus && matchesParent;
    });
  }, [searchTerm, entities, entitySearchStatus, entitySearchParent]);

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const pageData = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  const toggleSelect = id =>
    setSelectedIds(ids =>
      ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
    );

  const toggleAll = () => {
    if (selectedIds.length === pageData.length) setSelectedIds([]);
    else setSelectedIds(pageData.map(d => d.entity_id));
  };

  const onRowClick = row => {
    setSelectedRow(row);
    setDrawerTab('entity-info');
    setDrawerOpen(true);
  };

  const onWpRowClick = row => {
    setSelectedWorkspace(row);
    setWpDrawerTab('workplace-info');
    setWpDrawerOpen(true);
  };

  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const dropdownRef = useRef(null);
  const buttonRefs = useRef({});
  const drawerRef = useRef(null);

  const [wpDrawerOpen, setWpDrawerOpen] = useState(false);
  const [wpDrawerTab, setWpDrawerTab] = useState('workplace-info');
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const wpDrawerRef = useRef(null);

  const currentRow = entities.find(e => e.entity_id === dropdownOpenId);

  const editEntry = () => {
    if (selectedIds.length == 1) {
      history.push(`/company/edit-entities/${selectedIds[0]}`);
    }
  };

  const deleteEntry = async () => {
    if (selectedIds.length) {
      let body = { 'entities': selectedIds };
      if (window.confirm("Are you sure want to delete?")) {
        const response = await apiHelper('entities/delete/', 'POST', body);
        if (response.ok) {
          const new_entities = entities.filter(entity => !selectedIds.includes(entity.entity_id));
          setEntities(new_entities);
          setSelectedIds([]);
          alert("Entity Successfully Deleted");
        }
      }
    }
  };
  console.log("location state", location.state);
useEffect(() => {
  if (location.state?.activeTab) {
    setActiveTab(location.state.activeTab);
  }
}, [location.state]);
  const deleteWorkplace = async () => {
    if (!wpSelectedIds.length) return;
    if (!window.confirm("Are you sure want to delete?")) return;
    const res = await apiHelper('entities/workplaces-delete/', 'POST', { workplaces: wpSelectedIds });
    if (res.ok) {
      setWorkplaces(workplaces.filter(w => !wpSelectedIds.includes(w.workplace_id)));
      setWpSelectedIds([]);
      alert("Workplace Successfully Deleted");
    }
  };

  const editWorkplace = () => {
    if (wpSelectedIds.length == 1) {
      history.push(`/company/edit-workplaces/${wpSelectedIds[0]}`);
    }
  };

  useEffect(() => {
    async function fetchOrganisation() {
      const response = await apiHelper('entities/organisation/');
      if (response && response.ok) {
        const result = await response.json();
        setOrganisation(result);
      }
    }

    async function fetchWorkplaces() {
      const response = await apiHelper('entities/workplaces/');
      if (response && response.ok) {
        const result = await response.json();
        setWorkplaces(result);
        console.log("Fetched workplaces:", result);
      }
    }

    async function fetchData() {
      const response = await apiHelper('entities/list/');
      if (response && response.ok) {
        const result = await response.json();
        setEntities(result);
      }
    }
    fetchOrganisation();
    fetchData();
    fetchWorkplaces();
  }, []);

  useEffect(() => {
    function handleClickOutsideDrawer(event) {
      if (
        drawerOpen &&
        drawerRef.current &&
        !drawerRef.current.contains(event.target)
      ) {
        setDrawerOpen(false);
        setSelectedRow(null);
        setSelectedIds(ids =>
          selectedRow ? ids.filter(id => id !== selectedRow.entity_id) : ids
        );
      }
    }
    document.addEventListener('mousedown', handleClickOutsideDrawer);
    return () =>
      document.removeEventListener('mousedown', handleClickOutsideDrawer);
  }, [drawerOpen, selectedRow]);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRefs.current[dropdownOpenId]?.contains(event.target)
      ) {
        setDropdownOpenId(null);
      }
    }

    if (dropdownOpenId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpenId]);

  const toggleDropdown = (id) => {
    if (dropdownOpenId === id) {
      setDropdownOpenId(null);
    } else {
      const btn = buttonRefs.current[id];
      if (btn) {
        const rect = btn.getBoundingClientRect();
        const dropdownWidth = 150;
        const dropdownHeight = 100;
        let left = rect.left + window.scrollX - dropdownWidth + rect.width;
        if (left < window.scrollX + 8) {
          left = window.scrollX + 8;
        }
        let top = rect.bottom + window.scrollY;
        if (top + dropdownHeight > window.scrollY + window.innerHeight) {
          top = rect.top + window.scrollY - dropdownHeight;
        }
        setDropdownPosition({ top, left });
      }
      setDropdownOpenId(id);
    }
  };

  const filteredWorkplaces = useMemo(() => {
    const term = wpSearchTerm.toLowerCase();

    // 🔹 FILTERING
    const result = workplaces.filter(w => {
      const address = [
        w.street_address,
        w.street_address_2,
        w.city,
        w.state,
        w.post_code,
        w.country
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      const matchesSearch =
        !wpSearchTerm ||
        (w.workplace_name?.toLowerCase().includes(term)) ||
        (w.uuid?.toLowerCase().includes(term)) ||
        (w.workplace_short_name?.toLowerCase().includes(term)) ||
        (w.notes?.toLowerCase().includes(term)) ||
        address.includes(term);

      const matchesStatus =
        wpSearchStatus.length === 0 ||
        wpSearchStatus.includes(w.status_text);

      const matchesLocationType =
        wpSearchLocationType.length === 0 ||
        wpSearchLocationType.includes(w.location_type);

      const matchesAddress =
        wpSearchAddress.length === 0 ||
        wpSearchAddress.some(addr =>
          address.includes(addr.toLowerCase())
        );

      return (
        matchesSearch &&
        matchesStatus &&
        matchesLocationType &&
        matchesAddress
      );
    });

    // 🔹 SORTING (NEW ADDITION)
    if (!sortField) return result;

    const sorted = [...result];

    sorted.sort((a, b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];

      if (aVal == null || bVal == null) return 0;

      // date sorting
      if (sortField === "modified_at") {
        return sortOrder === "asc"
          ? new Date(aVal) - new Date(bVal)
          : new Date(bVal) - new Date(aVal);
      }

      // string sorting
      if (typeof aVal === "string") {
        return sortOrder === "asc"
          ? String(aVal).localeCompare(String(bVal))
          : String(bVal).localeCompare(String(aVal));
      }

      // number sorting
      return sortOrder === "asc"
        ? aVal - bVal
        : bVal - aVal;
    });

    return sorted;

  }, [wpSearchTerm, workplaces, wpSearchStatus, wpSearchLocationType, wpSearchAddress, sortField, sortOrder]);

  const wpTotalPages = Math.ceil(filteredWorkplaces.length / PAGE_SIZE);
  const wpPageData = filteredWorkplaces.slice((wpCurrentPage - 1) * PAGE_SIZE, wpCurrentPage * PAGE_SIZE);

  const toggleSelectWp = id =>
    setWpSelectedIds(ids =>
      ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
    );

  const toggleAllWp = () => {
    if (wpSelectedIds.length === wpPageData.length) setWpSelectedIds([]);
    else setWpSelectedIds(wpPageData.map(d => d.workplace_id));
  };

  const [wpDropdownOpenId, setWpDropdownOpenId] = useState(null);
  const wpButtonRefs = useRef({});
  const [wpDropdownPosition, setWpDropdownPosition] = useState({ top: 0, left: 0 });

  const toggleWpDropdown = id => {
    if (wpDropdownOpenId === id) return setWpDropdownOpenId(null);
    const btn = wpButtonRefs.current[id];
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    let left = rect.left + window.scrollX - 150 + rect.width;
    if (left < 8) left = 8;
    let top = rect.bottom + window.scrollY;
    if (top + 100 > window.scrollY + window.innerHeight)
      top = rect.top + window.scrollY - 100;
    setWpDropdownPosition({ top, left });
    setWpDropdownOpenId(id);
  };

  const wpCurrentRow = workplaces.find(e => e.workplace_id === wpDropdownOpenId);

  const handleWpToggleStatus = async (row) => {
    const activate = row.status_text !== 'Active';
    const action = activate ? 'activate' : 'deactivate';
    setActivateFailedMessage('');
    const response = await apiHelper(`entities/workplaces-update-status/${row.workplace_id}/`, 'POST', { status: action });
    if (response.ok) {
      setWorkplaces(workplaces.map(w =>
        w.workplace_id === row.workplace_id
          ? { ...w, status_text: activate ? 'Active' : 'Inactive' }
          : w
      ));
      setWpDropdownOpenId(null);
    } else if (response.status === 400) {
      const response_errors = await response.json();
      setActivateFailedMessage(response_errors.detail);
    }
  };
  const sortedWorkplaces = useMemo(() => {
    if (!sortField) return filteredWorkplaces;

    return [...filteredWorkplaces].sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      // string safe compare
      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
      if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;

      return 0;
    });
  }, [filteredWorkplaces, sortField, sortOrder]);

  const filterButtonRef = useRef(null);
  const filterPopupRef = useRef(null);
  const [filterPopupOpen, setFilterPopupOpen] = useState(false);
  const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
  const [copied, setCopied] = useState(false);
  const wpFilterButtonRef = useRef(null);
  const wpFilterPopupRef = useRef(null);
  const [wpFilterPopupOpen, setWpFilterPopupOpen] = useState(false);
  const [wpFilterPosition, setWpFilterPosition] = useState({ top: 0, left: 0 });
  const [hasAutoOpened, setHasAutoOpened] = useState(false);


  const handleCheckboxChange = (setter, value) => (e) => {
    const isChecked = e.target.checked;
    setter(prev =>
      isChecked
        ? [...prev, value]
        : prev.filter(v => v !== value)
    );
    setCurrentPage(1);
  };

  const handleWpCheckboxChange = (setter, value) => (e) => {
    const isChecked = e.target.checked;
    setter(prev =>
      isChecked
        ? [...prev, value]
        : prev.filter(v => v !== value)
    );
    setWpCurrentPage(1);
  };

  useEffect(() => {
    if (filterPopupOpen && filterButtonRef.current) {
      const rect = filterButtonRef.current.getBoundingClientRect();
      setFilterPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
    }
  }, [filterPopupOpen]);

  useEffect(() => {
    if (wpFilterPopupOpen && wpFilterButtonRef.current) {
      const rect = wpFilterButtonRef.current.getBoundingClientRect();
      setWpFilterPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
    }
  }, [wpFilterPopupOpen]);

  useEffect(() => {
    function handleClickOutsideFilter(event) {
      if (
        filterPopupOpen &&
        filterPopupRef.current &&
        !filterPopupRef.current.contains(event.target) &&
        !filterButtonRef.current.contains(event.target)
      ) {
        setFilterPopupOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutsideFilter);
    return () => document.removeEventListener('mousedown', handleClickOutsideFilter);
  }, [filterPopupOpen]);

  useEffect(() => {
    function handleClickOutsideWpFilter(event) {
      if (
        wpFilterPopupOpen &&
        wpFilterPopupRef.current &&
        !wpFilterPopupRef.current.contains(event.target) &&
        !wpFilterButtonRef.current.contains(event.target)
      ) {
        setWpFilterPopupOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutsideWpFilter);
    return () => document.removeEventListener('mousedown', handleClickOutsideWpFilter);
  }, [wpFilterPopupOpen]);

  const entityFilterCount = [...entitySearchStatus, ...entitySearchParent].filter(Boolean).length;
  const wpFilterCount = [...wpSearchStatus, ...wpSearchLocationType, ...wpSearchAddress].filter(Boolean).length;

  const entityFilterSections = [
    {
      label: "Status",
      key: "status",
      type: "checkbox",
      options: ["Active", "Inactive"]
    },
    {
      label: "Parent Entity",
      key: "parentEntity",
      type: "list",
      data: [
        ...new Map(
          entities
            .filter(e => e.parent_name && e.parent_name !== "NA")
            .map(e => [
              e.parent_name,
              { id: e.parent_name, name: e.parent_name }
            ])
        ).values()
      ],
      renderItem: item => ({
        id: item.id,
        title: item.name
      })
    }
  ];


  const handleCopy = async (textToCopy) => {
    if (!textToCopy) {
      console.error('No text to copy');
      alert('Failed to copy: No text available.');
      return;
    }

    // Use Clipboard API if available and secure
    if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      try {
        await navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      } catch (err) {
        console.error('Clipboard API failed:', err);
        fallbackCopyTextToClipboard(textToCopy);
      }
    } else {
      console.warn('Clipboard API not available or not in secure context, using fallback');
      fallbackCopyTextToClipboard(textToCopy);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);

      if (successful) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } else {
        console.error('Fallback copy failed');
        alert('Failed to copy text. Please copy manually.');
      }
    } catch (err) {
      console.error('Fallback copy error:', err);
      alert('Failed to copy text. Please copy manually.');
    }
  };
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const autoOpen = query.get("autoOpen");
    const id = query.get("id");
    const tab = query.get("tab");

    if (autoOpen === "true" && tab === "workplaces" && id && wpPageData.length > 0) {
      setActiveTab(tab);
      const row = wpPageData.find(wp => String(wp.workplace_id) === id);
      if (row) {
        onWpRowClick(row); // 👈 this simulates clicking the row → opens drawer
      }
    }
  }, [location.search, wpPageData]);
  const [successMessage, setSuccessMessage] = useState("");
  const [activateFailedMessage, setActivateFailedMessage] = useState("");


  useEffect(() => {
    if (location.state?.success) {
      setSuccessMessage(location.state.success);

      // clear after 4s
      setTimeout(() => {
        setSuccessMessage("");
      }, 4000);
    }
  }, [location.state]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const wpFilterSections = [
    {
      label: "Status",
      type: "checkbox",
      key: "status",
      options: ["Active", "Inactive"],
    },
    {
      label: "Location Type",
      type: "simpleList",
      key: "location_type",
      data: [...new Set(workplaces.map(w => w.location_type))]
        .filter(Boolean)
        .map(v => ({ value: v })),
      renderItem: (item) => ({
        id: item.value,
        title: item.value,
      }),
    },
    {
      label: "Address",
      type: "simpleList",
      key: "address",
      data: [...new Set(
        workplaces.map(w =>
          [
            w.street_address,
            w.street_address_2,
            w.city,
            w.state,
            w.post_code,
            w.country,
          ]
            .filter(Boolean)
            .join(" ")
        )
      )].map(v => ({ value: v })),
      renderItem: (item) => ({
        id: item.value,
        title: item.value,
      }),
    },
  ];
  const applyWpFilters = () => {
    setWpSearchStatus(wpTempFilters.status || []);
    setWpSearchLocationType(wpTempFilters.location_type || []);
    setWpSearchAddress(wpTempFilters.address || []);

    setWpCurrentPage(1);
    setWpFilterOpen(false);
  };
  const clearWpFilters = () => {
    setWpTempFilters({});
    setWpSearchStatus([]);
    setWpSearchLocationType([]);
    setWpSearchAddress([]);
  };

  const FilterActiveIcon = () => (
    <svg style={{ margin: 0 }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <g clipPath="url(#clip0_4516_4830)">
        <path d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z" fill="#0D6EFD" />
      </g>
      <defs>
        <clipPath id="clip0_4516_4830">
          <rect width="12" height="12" fill="white" transform="translate(11 5)" />
        </clipPath>
      </defs>
    </svg>
  );

  const FilterInactiveIcon = () => (
    <svg style={{ margin: 0 }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );


  return (
    <div className="company-body">
      <div className="breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <span key={index} className="breadcrumb-item">
            {crumb}
            {index !== breadcrumbs.length - 1}
          </span>
        ))}
      </div>

      {successMessage && (
        <div
          className="d-flex align-items-center justify-content-between"
          role="alert"
          style={{
            boxShadow: "0px 4px 10px 0px #0000001F",
            padding: "15px 10px",
            borderRadius: "12px",
            border: "1px solid #28a745",   // green border
            backgroundColor: "#d4edda",    // light green background
            color: "#155724",              // dark green text
            fontSize: "12px",
            position: "fixed",
            top: "10px",
            width: "calc(100% - 20px)",
            maxWidth: "640px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2000,
          }}
        >
          <div className="d-flex align-items-center" style={{ gap: "6px" }}>
            <strong>{successMessage}</strong>
          </div>

          <X
            size={16}
            style={{ cursor: "pointer" }}
            onClick={() => setSuccessMessage("")}
          />
        </div>
      )}

      {activateFailedMessage && (
        <div
          className="d-flex align-items-center justify-content-between"
          role="alert"
          style={{
            boxShadow: "0px 4px 10px 0px #0000001F",
            padding: "15px 10px",
            borderRadius: "12px",
            border: "1px solid #DC3545",
            backgroundColor: "#F8D7DA",
            color: "#842029",
            fontSize: "12px",
            position: "fixed",
            top: "10px",
            width: "calc(100% - 20px)",
            maxWidth: "640px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2000,
          }}
        >
          <div className="d-flex align-items-center" style={{ gap: "6px" }}>
            <strong>{activateFailedMessage}</strong>
          </div>

          <X
            size={16}
            style={{ cursor: "pointer" }}
            onClick={() => setActivateFailedMessage('')}
          />
        </div>
      )}


      <div className="tabs">
        {["organisation-info", "entities", "workplaces"].map((tab) => (
          <button
            key={tab}
            className={`tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {formatTab(tab)}
          </button>
        ))}
      </div>

      {activeTab === "organisation-info" && (
        <div className="info-section">
          <div className="info-card">
            <div className="info-header">
              <h4 className="info-title">Organisation Name</h4>
            </div>
            <div className="info-content">
              <div><strong>{organisation.organisation_name}</strong></div>
              <button className="edit-btn" onClick={() => history.push("/company/edit-organisation")}>
                <Pencil size={24} />
                Edit Info
              </button>
            </div>
          </div>

          <div className="info-card">
            <div className="info-header">
              <h4 className="info-title">Basic Information</h4>
            </div>
            <div className="info-content">
              <div>
                <strong className="mb-2 notes-preserve">Notes</strong>
                <p>{organisation.notes}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "entities" && (
        <div className="info-section entities-cls-adding-here">
          <div className="info-card">
            <div className="info-header">
              <h4 className="info-title">Entities</h4>
            </div>

            <div className="entities-tab">
              <div className="toolbar">
                <div className="toolbar-left">
                  <div className="search-box">
                    <Search size={20} />
                    <input
                      type="text"
                      placeholder="Search…"
                      value={searchTerm}
                      onChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                  <div style={{ position: 'relative' }}>

                    <button
                      ref={filterButtonRef}
                      // className={`icon-btn p-2 filter-btn ${filtersApplied ? "applied" : ""}`}
                      className="icon-btn p-2 filter-btn"
                      onClick={() => setEntityFilterDrawerOpen(true)}
                      // disabled={isInitialTableEmpty}
                      style={{
                        border: "1px solid #6C757D",
                        borderWidth: "1px",
                        color: "#6C757D",

                        background: "#FFFFFF", // normal

                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        opacity: 1,
                        pointerEvents: "auto", // block actions
                        cursor: "pointer",
                        borderRadius: "8px",
                      }}
                    >
                      {/* {filtersApplied && !isInitialTableEmpty ? ( */}
                      {/* <FilterActiveIcon /> */}
                      {/* ) : ( */}
                      <FilterInactiveIcon />
                      {/* )} */}

                    </button>

                    <FilterDrawer
                      isOpen={entityFilterDrawerOpen}
                      onClose={() => setEntityFilterDrawerOpen(false)}
                      title="Entity Filter"
                      sections={entityFilterSections}
                      tempValues={entityFilterValues}
                      setTempValues={setEntityFilterValues}
                      onApply={() => {
                        setEntitySearchStatus(entityFilterValues.status || []);
                        setEntitySearchParent(entityFilterValues.parentEntity || []);
                        setEntityFilterDrawerOpen(false);
                      }}
                      onClear={() => {
                        setEntityFilterValues({
                          status: [],
                          parentEntity: [],
                          parentEntitySearch: ""
                        });

                        setEntitySearchStatus([]);
                        setEntitySearchParent([]);
                      }}
                    />
                  </div>
                </div>
                <div className="toolbar-right">
                  <button className="icon-btn" onClick={deleteEntry}><Trash2 size={18} /></button>
                  <button className="icon-btn" onClick={editEntry}><Edit2 size={18} /></button>
                  <button className="icon-btn" onClick={() => history.push("/company/add-entities")}><Plus size={18} /></button>
                </div>
              </div>

              {filterPopupOpen && (
                <div
                  ref={filterPopupRef}
                  className="filter-popup"
                  style={{
                    position: 'absolute',
                    top: filterPosition.top,
                    left: filterPosition.left,
                    background: '#fff',
                    padding: '16px',
                    borderRadius: '8px',
                    width: '300px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    zIndex: '1002',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                  }}
                >
                  <div className="filter-header" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                    <button className="close-btn" onClick={() => setFilterPopupOpen(false)}>
                      <X size={20} />
                    </button>
                  </div>

                  <div className="filter-content">
                    {/* Status */}
                    <div className="filter-section" style={{ marginBottom: '16px' }}>
                      <label className="form-label">Status</label>
                      <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                        {['Active', 'Inactive'].map(status => (
                          <label key={status} className="form-check" style={{ cursor: 'pointer', fontWeight: 400 }}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={entitySearchStatus.includes(status)}
                              onChange={handleCheckboxChange(setEntitySearchStatus, status)}
                            />
                            <span style={{ marginLeft: '8px' }}>{status}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Parent Entity */}
                    <div className="filter-section" style={{ marginBottom: '16px' }}>
                      <label className="form-label">Parent Entity</label>
                      <div className="search-box-filter" style={{
                        position: 'relative',
                        border: '1px solid #6c757d',
                        borderRadius: '.5rem',
                        padding: '4px',
                        minHeight: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '4px',
                        marginBottom: '6px'
                      }}>
                        {entitySearchParent.map(parent => (
                          <span
                            key={parent}
                            style={{
                              backgroundColor: '#FFEB00',
                              color: '#212529',
                              borderRadius: '16px',
                              padding: '4px 8px',
                              margin: '2px',
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '12px',
                              fontWeight: '600',
                              lineHeight: 'normal'
                            }}
                          >
                            {parent}
                            <button
                              onClick={() =>
                                handleCheckboxChange(setEntitySearchParent, parent)({ target: { checked: false } })
                              }
                              style={{
                                background: 'none',
                                border: 'none',
                                marginLeft: '20px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                padding: '0',
                                lineHeight: '14px'
                              }}
                            >
                              <X size={14} strokeWidth={3} />
                            </button>
                          </span>
                        ))}
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                          <Search size={16} style={{ marginRight: '4px' }} />
                          <input
                            type="text"
                            placeholder="Search Parent Entity…"
                            value={entityParentSearchTerm}
                            onChange={e => setEntityParentSearchTerm(e.target.value)}
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px' }}
                          />
                        </div>
                      </div>
                      <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                        {[...new Set(
                          entities
                            .filter(d => (d.parent_name || '').toLowerCase().includes(entityParentSearchTerm.toLowerCase()) && d.parent_name !== 'NA')
                            .map(d => d.parent_name)
                        )]
                          .slice(0, 3)
                          .map((parent, index) => (
                            <label key={index} className="form-check" style={{ cursor: 'pointer', fontWeight: 400 }}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={entitySearchParent.includes(parent)}
                                onChange={handleCheckboxChange(setEntitySearchParent, parent)}
                              />
                              <span style={{ marginLeft: '8px' }}>{parent}</span>
                            </label>
                          ))}
                      </div>
                    </div>
                  </div>

                  <div className="filter-footer" style={{ textAlign: 'center', marginTop: '10px' }}>
                    <button
                      className="filter-btn"
                      onClick={() => setFilterPopupOpen(false)}
                      style={{
                        background: 'black',
                        color: 'white',
                        padding: '8px 16px',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Filter
                    </button>
                  </div>
                </div>

              )}

              <div className="table-wrapper">
                <table className="entities-table">
                  <thead>
                    <tr>
                      <th>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedIds.length === pageData.length && pageData.length > 0}
                            onChange={toggleAll}
                          />
                        </div>
                      </th>
                      <SortableHeader
                        label="Entity Name"
                        field="entity_name"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />
                      <SortableHeader
                        label="UEN"
                        field="uen"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />
                      <SortableHeader
                        label="Status"
                        field="status_text"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />
                      <SortableHeader
                        label="Parent Entity"
                        field="parent_name"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />
                      <th style={{ textAlign: 'center' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageData.map((row, idx) => (
                      console.log("Rendering row:", row), // Debug log to check row data
                      <tr
                        key={row.entity_id}
                        className={[
                          idx % 2 ? 'striped' : '',
                          (selectedIds.includes(row.entity_id) || selectedRow?.entity_id === row.entity_id)
                            ? 'row-selected'
                            : ''
                        ].join(' ')}
                        onClick={() => onRowClick(row)}
                      >
                        <td>
                          <div className='form-check' onClick={e => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={selectedIds.includes(row.entity_id)}
                              onChange={e => {
                                toggleSelect(row.entity_id);
                                if (e.target.checked) {
                                  setSelectedRow(row);
                                } else if (selectedRow?.entity_id === row.entity_id) {
                                  setSelectedRow(null);
                                }
                              }}
                            />
                          </div>
                        </td>
                        <td>{row.entity_name}</td>
                        <td>{row.uen}</td>
                        <td>
                          <span className={`status ${row.status_text.toLowerCase()}`}>
                            {row.status_text}
                          </span>
                        </td>
                        <td>{row.parent_name || 'NA'}</td>
                        <td style={{ textAlign: "center", position: "relative" }}>
                          <button
                            ref={(el) => (buttonRefs.current[row.entity_id] = el)}
                            className="icon-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleDropdown(row.entity_id);
                            }}
                          >
                            <MoreHorizontal size={20} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {dropdownOpenId !== null && (
                  <div
                    ref={dropdownRef}
                    className='backdrop-cls'
                    style={{
                      position: "absolute",
                      top: dropdownPosition.top,
                      left: dropdownPosition.left,
                      background: "white",
                      boxShadow: "0px 1px 4px 0px #0000001A",
                      zIndex: 1000,
                      minWidth: 152,
                      borderRadius: 8,
                      padding: 12,
                    }}
                    onClick={e => e.stopPropagation()}
                  >
                    <div className='btn-align-forall'>
                      <div className='common-for-all'>
                        <button
                          onClick={() => {
                            onRowClick(currentRow);
                            setDropdownOpenId(null); // 👈 Close dropdown
                          }}
                        >
                          View Details
                        </button>
                      </div>

                      <div className='common-for-all'>
                        <button
                          onClick={() => {
                            history.push(`/company/edit-entities/${currentRow.entity_id}`);
                            setDropdownOpenId(null); // 👈 Close dropdown
                          }}
                        >
                          Edit
                        </button>
                      </div>

                      <div className='common-for-all'>
                        <button
                          onClick={() => {
                            handleToggleStatus(currentRow);
                            setDropdownOpenId(null); // 👈 Close dropdown
                          }}
                          className='deactivate-cls'
                        >
                          {currentRow.status_text === 'Active' ? 'Deactivate' : 'Activate'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {filtered.length > 0 && (
                <div className="pagination" style={{ marginTop: 16 }}>
                  <div className="pagination-info">
                    {`${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(currentPage * PAGE_SIZE, filtered.length)
                      } of ${filtered.length}`}
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {drawerOpen && selectedRow && (
        <>
          <div className="drawer-overlay" />
          <div className="entity-drawer" ref={drawerRef}>
            <div className="drawer-header">
              <h3>Entities Info</h3>
              <button
                className="close-btn"
                onClick={() => {
                  setDrawerOpen(false);
                  setSelectedIds((ids) => ids.filter(id => id !== selectedRow?.entity_id));
                  setSelectedRow(null);
                }}
              >
                <X size={24} />
              </button>
            </div>
            <div className='main-drawer-inner'>
              <div className='drawer-title'>
                <h2>{selectedRow.entity_name}</h2>
              </div>
              <div className="drawer-tabs">
                <button
                  className={drawerTab === 'entity-info' ? 'active' : ''}
                  onClick={() => setDrawerTab('entity-info')}
                >
                  Entity Info
                </button>
                <button
                  className={drawerTab === 'additional-info' ? 'active' : ''}
                  onClick={() => setDrawerTab('additional-info')}
                >
                  Additional Info
                </button>
              </div>
              <div className="drawer-content">
                {drawerTab === 'entity-info' ? (
                  <div className="tab-panel entity-info-panel">
                    <div className="field-block">
                      <div className="field-label">Entity Name</div>
                      <div className="field-value">{selectedRow.entity_name}</div>
                    </div>
                    <div className="field-block">
                      <div className="field-label">Open ID</div>
                      <div className="field-value d-flex align-items-center gap-2">
                        <span
                          style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }}
                          onClick={() => handleCopy(selectedRow.uuid)}
                        >
                          {selectedRow.uuid}
                        </span>
                        <Copy
                          size={13}
                          onClick={() => handleCopy(selectedRow.uuid)}
                          style={{ cursor: "pointer", color: "#2C7BE5" }}
                        />
                        {copied && <span style={{ fontSize: '12px', color: "#2C7BE5" }}>Copied!</span>}
                      </div>
                    </div>
                    <div className="field-block">
                      <div className="field-label">Status</div>
                      <div className="field-value">
                        <span className={`status ${selectedRow.status_text.toLowerCase()}`}>
                          {selectedRow.status_text}
                        </span>
                      </div>
                    </div>
                    <div className="field-block">
                      <div className="field-label">UEN</div>
                      <div className="field-value">{selectedRow.uen}</div>
                    </div>
                    <div className="field-block">
                      <div className="field-label">Short Name</div>
                      <div className="field-value">{selectedRow.entity_short_name}</div>
                    </div>
                  </div>
                ) : (
                  <div className="tab-panel additional-info-panel">
                    <p className='note-type-added'>Note</p>
                    <label className='no-description-cls notes-preserve'>{selectedRow.note}</label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {activeTab === "workplaces" && (
        <div className="info-section">
          <div className="info-card">
            <div className="info-header">
              <h4 className="info-title">Workplaces</h4>
            </div>
            <div className="entities-tab">
              <div className="toolbar">
                <div className="toolbar-left">
                  <SearchBox
                    searchInput={wpSearchTerm}
                    setSearchInput={setWpSearchTerm}
                    setSearchTerm={setWpSearchTerm}
                    setCurrentPage={setWpCurrentPage}
                    disabled={false}
                  />

                  <div style={{ position: 'relative' }}>
                    <button
                      ref={filterButtonRef}
                      // className={`icon-btn p-2 filter-btn ${filtersApplied ? "applied" : ""}`}
                      className="icon-btn p-2 filter-btn"
                      // onClick={() => setFilterPopupOpen(!filterPopupOpen)}
                      onClick={() => setWpFilterOpen(prev => !prev)}
                      // disabled={isInitialTableEmpty}
                      style={{
                        // border: filtersApplied ? "1px solid #2C7BE5" : "1px solid #6C757D",
                        border: "1px solid #6C757D",
                        borderWidth: "1px",
                        // color: filtersApplied ? "#2C7BE5" : "#6C757D",
                        color: "#6C757D",
                        background: "#FFFFFF",

                        // background: isInitialTableEmpty
                        //     ? "#E9ECEF" // disabled background
                        //     : filtersApplied
                        //         ? "#CFE2FF" // active filter
                        //         : "#FFFFFF", // normal

                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        // opacity: isInitialTableEmpty ? 0.6 : 1,
                        opacity: 1,
                        pointerEvents: "auto",
                        cursor: "pointer",
                        // pointerEvents: isInitialTableEmpty ? "none" : "auto", // block actions
                        // cursor: isInitialTableEmpty ? "not-allowed" : "pointer",
                        borderRadius: "8px",
                      }}
                    >
                      {/* {filtersApplied && !isInitialTableEmpty ? (
                                                        <FilterActiveIcon />
                                                    ) : (
                                                        <FilterInactiveIcon />
                                                    )} */}
                      <FilterInactiveIcon />
                    </button>
                    <FilterDrawer
                      isOpen={wpFilterOpen}
                      onClose={() => setWpFilterOpen(false)}
                      sections={wpFilterSections}
                      tempValues={wpTempFilters}
                      setTempValues={setWpTempFilters}
                      onApply={applyWpFilters}
                      onClear={clearWpFilters}
                      title="Filter"
                    />
                  </div>
                </div>
                <div className="toolbar-right">
                  <button className="icon-btn" onClick={deleteWorkplace}><Trash2 size={18} /></button>
                  <button className="icon-btn"><Edit2 onClick={editWorkplace} size={18} /></button>
                  <button className="icon-btn" onClick={() => history.push("/company/add-workplaces")}><Plus size={18} /></button>
                </div>
              </div>


              <div className="table-wrapper">
                <table className="entities-table">
                  <thead>
                    <tr>
                      <th>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={wpSelectedIds.length === wpPageData.length && wpPageData.length > 0}
                            onChange={toggleAllWp}
                          />
                        </div>
                      </th>
                      <SortableHeader
                        label="Name"
                        field="workplace_name"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />
                      <SortableHeader
                        label="Status"
                        field="status_text"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />
                      <SortableHeader
                        label="ID"
                        field="workplace_id"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />

                      <SortableHeader
                        label="Workplace Type"
                        field="location_type"
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                      />
                      <th style={{ textAlign: 'center' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {wpPageData.map((row, idx) => (
                      <tr key={row.workplace_id}
                        className={[
                          idx % 2 ? 'striped' : '',
                          (wpSelectedIds.includes(row.workplace_id) || selectedWorkspace?.workplace_id === row.workplace_id)
                            ? 'row-selected' : ''
                        ].join(' ')}
                        onClick={() => onWpRowClick(row)}
                      >
                        <td onClick={e => e.stopPropagation()}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={wpSelectedIds.includes(row.workplace_id)}
                              onChange={() => toggleSelectWp(row.workplace_id)}
                            />
                          </div>
                        </td>
                        <td>{row.workplace_name}</td>
                        <td><span className={`status ${row.status_text.toLowerCase()}`}>{row.status_text}</span></td>
                        <td>{row.workplace_id}</td>
                        <td>{row.location_type}</td>
                        <td style={{ textAlign: 'center', position: 'relative' }}>
                          <button
                            ref={el => wpButtonRefs.current[row.workplace_id] = el}
                            className="icon-btn"
                            onClick={e => { e.stopPropagation(); toggleWpDropdown(row.workplace_id); }}
                          >
                            <MoreHorizontal size={20} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {wpDropdownOpenId !== null && (
                  <div
                    className="backdrop-cls"
                    style={{
                      position: 'absolute',
                      top: wpDropdownPosition.top,
                      left: wpDropdownPosition.left,
                      background: 'white',
                      boxShadow: '0px 1px 4px #0000001A',
                      zIndex: 1000,
                      minWidth: 152,
                      borderRadius: 8,
                      padding: 12
                    }}
                    onClick={e => e.stopPropagation()}
                  >
                    <div className="btn-align-forall">
                      <div className="common-for-all">
                        <button
                          onClick={() => {
                            onRowClick(wpCurrentRow);
                            setDropdownOpenId(null); // 👈 Close dropdown
                          }}
                        >
                          View Details
                        </button>
                      </div>

                      <div className="common-for-all">
                        <button
                          onClick={() => {
                            history.push(`/company/edit-workplaces/${wpCurrentRow.workplace_id}`);
                            setDropdownOpenId(null); // 👈 Close dropdown
                          }}
                        >
                          Edit
                        </button>
                      </div>

                      <div className="common-for-all">
                        <button
                          onClick={() => {
                            handleWpToggleStatus(wpCurrentRow);
                            setDropdownOpenId(null); // 👈 Close dropdown
                          }}
                          className="deactivate-cls"
                        >
                          {wpCurrentRow.status_text === 'Active' ? 'Deactivate' : 'Activate'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {filteredWorkplaces.length > 0 && (
                <div className="pagination" style={{ marginTop: 16 }}>
                  <div className="pagination-info">
                    {`${(wpCurrentPage - 1) * PAGE_SIZE + 1} - ${Math.min(wpCurrentPage * PAGE_SIZE, filteredWorkplaces.length)
                      } of ${filteredWorkplaces.length}`}
                  </div>

                  <Pagination
                    currentPage={wpCurrentPage}
                    totalPages={wpTotalPages}
                    onPageChange={setWpCurrentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {wpDrawerOpen && selectedWorkspace && (
        <>
          <div className="drawer-overlay" />
          <div className="entity-drawer" ref={wpDrawerRef}>
            <div className="drawer-header">
              <div className="d-flex align-items-center gap-1">
                {location.search.includes("from=branch") && (
                  <button
                    className="back-btn"
                    onClick={() => {
                      const query = new URLSearchParams(location.search);
                      const branchId = query.get("branchId");

                      history.push(`/branches?id=${branchId}&autoOpen=true`);
                      setDrawerOpen(false);
                      setSelectedRow(null);
                      setHasAutoOpened(false);
                    }}
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      padding: 0,
                      margin: 0,
                      cursor: "pointer",
                    }}
                  >
                    <ChevronLeft size={24} />
                  </button>
                )}

                <h3>Workplace Info</h3>
              </div>
              <button
                className="close-btn"
                onClick={() => setWpDrawerOpen(false)}
              >
                <X size={24} />
              </button>
            </div>
            <div className="main-drawer-inner">
              <div className="drawer-title">
                <h2>{selectedWorkspace.workplace_name}</h2>
              </div>
              <div className="drawer-tabs">
                <button
                  className={wpDrawerTab === 'workplace-info' ? 'active' : ''}
                  onClick={() => setWpDrawerTab('workplace-info')}
                >
                  Details Info
                </button>
                <button
                  className={wpDrawerTab === 'additional-info' ? 'active' : ''}
                  onClick={() => setWpDrawerTab('additional-info')}
                >
                  Additional Info
                </button>
              </div>
              <div className="drawer-content">
                {wpDrawerTab === 'workplace-info' ? (
                  <>
                    <div className="tab-panel entity-info-panel">
                      <div className="field-block">
                        <div className="field-label">Name</div>
                        <div className="field-value">{selectedWorkspace.workplace_name}</div>
                      </div>
                      <div className="field-block">
                        <div className="field-label">Open ID</div>
                        <div className="field-value d-flex align-items-center gap-2">
                          <span
                            style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }}
                            onClick={() => handleCopy(selectedWorkspace.uuid)}
                          >
                            {selectedWorkspace.uuid}
                          </span>
                          <Copy
                            size={13}
                            onClick={() => handleCopy(selectedWorkspace.uuid)}
                            style={{ cursor: "pointer", color: "#2C7BE5" }}
                          />
                          {copied && <span style={{ fontSize: '12px', color: "#2C7BE5" }}>Copied!</span>}
                        </div>
                      </div>
                      <div className="field-block">
                        <div className="field-label">Status</div>
                        <div className="field-value">
                          <span className={`status ${selectedWorkspace.status_text.toLowerCase()}`}>
                            {selectedWorkspace.status_text}
                          </span>
                        </div>
                      </div>
                      <div className="field-block">
                        <div className="field-label">Short Name</div>
                        <div className="field-value">{selectedWorkspace.workplace_short_name}</div>
                      </div>
                      <div className="field-block">
                        <div className="field-label">Location Type</div>
                        <div className="field-value">{selectedWorkspace.location_type}</div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="tab-panel additional-info-panel">
                    <div className="field-block">
                      <div className="field-label">Note</div>
                      <div className="field-value notes-preserve">{selectedWorkspace.notes}</div>
                    </div>
                    {selectedWorkspace.location_type === 'Onsite' && (
                      <div>
                        <div className="field-block">
                          <div className="field-label">Address Line 1</div>
                          <div className="field-value">{selectedWorkspace.address.street_address || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                        </div>
                        <div className="field-block">
                          <div className="field-label">Address Line 2</div>
                          <div className="field-value">{selectedWorkspace.address.street_address_2 || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                        </div>
                        <div className="field-block">
                          <div className="field-label">City</div>
                          <div className="field-value">{selectedWorkspace.address.city || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                        </div>
                        <div className="field-block">
                          <div className="field-label">State</div>
                          <div className="field-value">{selectedWorkspace.address.state || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                        </div>
                        <div className="field-block">
                          <div className="field-label">Post Code</div>
                          <div className="field-value">{selectedWorkspace.address.post_code || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                        </div>
                        <div className="field-block">
                          <div className="field-label">Country</div>
                          <div className="field-value">{selectedWorkspace.address.country || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                        </div>
                        <div className="field-block">
                          <div className="field-label">Google Link</div>
                          <div className="field-value">{selectedWorkspace.address.google_map_link || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Company;